import api from './axios';

const contactService = {
  send: (data) => api.post('/contact', data),
  getAll: () => api.get('/contact'),
  reply: (id, message) => api.post(`/contact/${id}/reply`, { message }),
};

export default contactService;
